import React, {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import about from '../Assets/about.jpg'

export default function AboutUs() {
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);
  return (
    <>
    <section id="AboutUs" className="about section-bg pt-5">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>About</h2>
            <h3>Find Out More <span>About Us</span></h3>
          </div>
          <div className="row">
            <div className="col-lg-6" data-aos="zoom-in" data-aos-delay="100">
              <img src={about} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="100">
              <p className="font-italic">RAYAN Info Solutions is Kanpur Based Software Company, Engaged in providing software solutions from last 10 Years. Backed by our Strong quality process and rich experience in managing client across various domains, we strive for continuous innovations in our offerings.</p>
              <ul>
                <li>
                  <i className="bi bi-shop"></i>
                  <div>
                    <h5>Hardworking Team</h5>
                    <p>Our team is highly knowledgeable, experienced, committed and believes in complementing our robust products with reliable services and support.</p>
                  </div>
                </li>
                <li>
                  <i className="bi bi-images"></i>
                  <div>
                    <h5>Customized Solutions</h5>
                    <p>We deal with solutions to your extreme organization that best suits to your requirement this includes customized Software Development with your global presence.</p>
                  </div>
                </li>
              </ul>
              <p>RAYAN Info Solutions always committed on delivering Customized software and attractive web solutions for different kinds of businesses which represent you globally. We Design accurate solutions for your business. We deal in following domain i.e.  ERP Solutions, Web Solutions & Website, Customized Software, Mobile Compatible Website, Mobile apps native and Hybrid, SMS & Payment Gateway Integration</p>
            </div>
          </div>
        </div>
    </section>
    </>
  )
}
